import { CSSObject } from '@chakra-ui/react';
import Maintenance from '../../../assets/betgalaxy/images/backgrounds/maintenance.png';

export const Mascot: CSSObject = {
  w: '300px',
  h: '300px',
  m: 'auto',
  bgImage: `url(${Maintenance})`,
};
